import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ToastrService } from "ngx-toastr";
import { FinanciamientoApiService } from "src/app/services/financiamiento-reusable.service";
import { MediaMatcher } from "@angular/cdk/layout";
import { MatAccordion } from "@angular/material/expansion";
import { Globals } from "src/app/globals";
import { find } from "rxjs/operators";
import { SupplyService } from "src/app/services/supply.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { VisorDocumentosComponent } from "../visor-documentos/visor-documentos.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { DialogoConfirmacionComponent } from "../dialogo-confirmacion/dialogo-confirmacion.component";

@Component({
  selector: "app-registrar-solicitante",
  templateUrl: "./registrar-solicitante.component.html",
  styleUrls: ["./registrar-solicitante.component.scss"],
})
export class RegistrarSolicitanteComponent implements OnInit, OnDestroy {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  panelOpenState = false;

  @BlockUI() blockUI: NgBlockUI;
  navigationSubscription;
  token: string;
  flagCodigovalidacion: boolean;
  flagEnviar: boolean = true;
  toggle: boolean = true;
  mobileQuery: MediaQueryList;
  data: any;
  datos: FormGroup;
  //limitFile: string = "";
  limitFile_pdf: number;
  limitFile_jpg: number;
  codigoValidacion: string;
  codigoValidacionWeb: string;
  correoTemporal: string;
  showSuministro = true;
  mailValido: boolean = false;
  disableRUC: boolean = false;

  correoValiRemitente: string ="";
  correoValiAsunto: string ="";
  correoValiParrafo01: string ="";
  correoValiParrafo02: string ="";

  tiposDocumento = [
    {
      tipo: "",
      descripcion: "<<Seleccione>>",
    },
  ];
  parentescos = [
    {
      cod: "",
      descCod: "<<Seleccione>>",
    },
  ];

  dataSource: any[] = [];
  filesMap: Map<number, any> = new Map<number, any>();
  sizeFile: number = 0;

  private _mobileQueryListener: () => void;

  constructor(
    private supplyService: SupplyService,
    private toastr: ToastrService,
    private financiamientoApiService: FinanciamientoApiService,
    private router: Router,
    private actRoute: ActivatedRoute,
    private globals: Globals,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public dialog: MatDialog
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd && this.showSuministro === false) {
        this.showSuministro = true;
        this.ngOnInit();
      }
    });

    this.datos = new FormGroup({
      suministro: new FormControl("", Validators.required),
      parentesco: new FormControl("", Validators.required),
      nombres: new FormControl("", Validators.required),
      paterno: new FormControl("", Validators.required),
      materno: new FormControl("", Validators.required),
      tipDocumento: new FormControl("", Validators.required),
      numDocumento: new FormControl("", Validators.required),
      telefono: new FormControl(""),
      celular: new FormControl("", Validators.required),
      correo: new FormControl("", [Validators.required, Validators.email]),
      codigo1: new FormControl("", Validators.required),
      codigo2: new FormControl("", Validators.required),
      codigo3: new FormControl("", Validators.required),
      codigo4: new FormControl("", Validators.required),
    });

    /*if(this.globals.tip_docum.toString() ==='TD002'){
      this.datos.controls['nombres'].disable();
      this.datos.controls['materno'].disable();

    }else{
      this.datos.controls['nombres'].enable();
    }*/
    //this.datos.controls['telefono'].clearValidators();
  }

  get f() {
    return this.datos.controls;
  }

  ngOnInit() {
    console.log('this.globals.tip_docum: '+this.globals.tip_docum)
    if (
      this.globals.tip_docum === "" ||
      this.globals.suministro === "" ||
      this.globals.num_docum === ""
    ) {
      this.toastr.warning("Se perdió la conexión, vuelva a ingresar para continuar. Datos del solicitante no encontrados", "Atención", {
        timeOut: 5000,
      });
      this.router.navigate(["/iniciar-sesion"]);
      return;
    }else{
      if(this.globals.tip_docum.toString() ==='TD002'){
        this.disableRUC=true;
      }else{
        this.disableRUC=false;
      }

    }

    // Obtener Tipo Documentos
    this.financiamientoApiService.getTipoDocumentos().subscribe((response) => {
      this.tiposDocumento = this.tiposDocumento.concat(response.resultado);
    });

    // Obtener Tipos de Parentesco
    this.financiamientoApiService.getParentescos().subscribe((response) => {
      this.parentescos = this.parentescos.concat(response.resultado);
    });

    this.initSolicitante();
    // Obtener limite capacidad de archivos para PDF
    let strLimitFilePDF: string;
    const bodyPDF = {
      clase: "FW_DIRECTORIO_TRABAJO",
      modulo: "ACUERDOS_WEB",
      categoria: "TAMANIO_ARCHIVO_MegaBytes_PDF"
    };
    this.financiamientoApiService.getParametrosGc(bodyPDF).subscribe((response) => {
      strLimitFilePDF = response.resultado.find((x) => x.categoria == "TAMANIO_ARCHIVO_MegaBytes_PDF").valor;
      console.log("strLimitFilePDF",strLimitFilePDF);
      this.limitFile_pdf = parseInt(strLimitFilePDF);
    });

    // Obtener limite capacidad de archivos para JPG
    let strLimitFileJPG: string;
    const bodyJPG = {
      clase: "FW_DIRECTORIO_TRABAJO",
      modulo: "ACUERDOS_WEB",
      categoria: "TAMANIO_ARCHIVO_MegaBytes_JPG"
    };
    this.financiamientoApiService.getParametrosGc(bodyJPG).subscribe((response) => {
      strLimitFileJPG = response.resultado.find((x) => x.categoria == "TAMANIO_ARCHIVO_MegaBytes_JPG").valor;
      console.log("strLimitFileJPG",strLimitFileJPG);
      this.limitFile_jpg = parseInt(strLimitFileJPG);
    });

    // Obtener remitente del correo de validacion
    const bodyCorreoRemitente = {
      clase: "FW_NOTIFICACION_VALIDA_CORREO",
      modulo: "ACUERDOS_WEB",
      categoria: "REMITENTE"
    };
    this.financiamientoApiService.getParametrosGc(bodyCorreoRemitente).subscribe((response) => {
      this.correoValiRemitente = response.resultado.find((x) => x.categoria == "REMITENTE").valor;
      console.log('this.correoValiRemitente: '+this.correoValiRemitente);
    });

    // Obtener asunto del correo de validacion
    const bodyCorreoAsunto = {
      clase: "FW_NOTIFICACION_VALIDA_CORREO",
      modulo: "ACUERDOS_WEB",
      categoria: "ASUNTO"
    };
    this.financiamientoApiService.getParametrosGc(bodyCorreoAsunto).subscribe((response) => {
      this.correoValiAsunto = response.resultado.find((x) => x.categoria == "ASUNTO").valor;
      console.log('this.correoValiAsunto: '+this.correoValiAsunto);
    });

    // Obtener parrafo01 del correo de validacion
    const bodyCorreoParrafo01 = {
      clase: "FW_NOTIFICACION_VALIDA_CORREO",
      modulo: "ACUERDOS_WEB",
      categoria: "PARRAFO_01"
    };
    this.financiamientoApiService.getParametrosGc(bodyCorreoParrafo01).subscribe((response) => {
      this.correoValiParrafo01 = response.resultado.find((x) => x.categoria == "PARRAFO_01").valor;
      console.log('this.correoValiParrafo01: '+this.correoValiParrafo01);
    });

    // Obtener parrafo02 del correo de validacion
    const bodyCorreoParrafo02 = {
      clase: "FW_NOTIFICACION_VALIDA_CORREO",
      modulo: "ACUERDOS_WEB",
      categoria: "PARRAFO_02"
    };
    this.financiamientoApiService.getParametrosGc(bodyCorreoParrafo02).subscribe((response) => {
      this.correoValiParrafo02 = response.resultado.find((x) => x.categoria == "PARRAFO_02").valor;
      console.log('this.correoValiParrafo02: '+this.correoValiParrafo02);
    });


  }

  irInicioSesion() {
    this.router.navigate(["/iniciar-sesion"]);
  }

  buscarDocs() {
    this.dataSource = [];
    const body = {
      parentescoCod: this.datos.value.parentesco.toString(),
    };

    this.financiamientoApiService
      .getDocsParentesco(body)
      .toPromise()
      .then((response) => {
        this.filesMap.clear();
        this.dataSource = response.resultado;
      });
  }

  async verEvent(event: any) {
    let file = this.filesMap.get(event.id).file;
    const dialogRef = this.dialog.open(VisorDocumentosComponent, {
      data: {
        src: await this.getBase64(file),
        nombre: file.name,
        tipo: file.type,
      },
    });
  }

  async getBase64(file: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  getFileChanged(j: number, filename: string) {
    let returned: string = "";
    let tipoExtension: string;
    let nroSuministro: string = "0";
    let nroDocumento: string;

    tipoExtension = filename.split(".").pop();
    nroSuministro = this.globals.suministro.toString();
    nroDocumento  = this.globals.num_docum.toString();

    returned = nroSuministro+"_"+nroDocumento+"_"+(j)+"."+tipoExtension;
    return returned;
  }

  adjuntarEvent(event: any) {
    let flagExcedido: boolean = false;
    let msjeExcedido: string = '';
    let factor: number = 1048576;
    let capacidad_PDF:number = factor * this.limitFile_pdf;
    let capacidad_JPG:number = factor * this.limitFile_jpg;

    console.log("capacidad_PDF",capacidad_PDF);
    console.log("capacidad_JPG",capacidad_JPG);

      console.log('NUEVO event.file.name.split(".")[0]: '+event.file.name.split(".")[1])

      let tipoExt = event.file.type === 'image/jpeg' ? 'jpg' : 'pdf';

      console.log('event.file.size: '+event.file.size);

      let sizeFile:number = event.file.size;


      if(tipoExt==='pdf'){

        if (capacidad_PDF < sizeFile) {
          flagExcedido = true;
          msjeExcedido="El documento adjunto ha excedido el límite máximo permitido para PDF: "+this.limitFile_pdf+" MB";
        } else {
          flagExcedido = false;
        }

      }else{

        if (capacidad_JPG < sizeFile) {
          flagExcedido = true;
          msjeExcedido="El documento adjunto ha excedido el límite máximo permitido para JPG: "+this.limitFile_jpg+" MB";
        } else {
          flagExcedido = false;
        }


      }

      if (flagExcedido) {
        this.toastr.warning(
          msjeExcedido,"Atención",
          { closeButton: true }
        );
      }else{

        this.filesMap.set(event.item.id, { file: event.file, item: event.item });
        let item = this.dataSource.find((x) => x.id === event.item.id);
        console.log("item",item);
        if (item) {
          item.docAdjunto = this.getFileChanged(item.id, event.file.name);
          item.tieneDocumento = true;
        }

      }

  }

  eliminarEvent(event: any) {
    this.mostrarDialogo(event);
  }

  mostrarDialogo(event: any): void {
    this.dialog
      .open(DialogoConfirmacionComponent, {
        data: `¿Desea eliminar el documento seleccionado?`
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.filesMap.delete(event.id);
          event.docAdjunto = "";
          event.tieneDocumento = false;
          this.toastr.success("Documento Eliminado satisfactoriamente.", "Confirmación", {closeButton: true,})
        }
    });
  }

  initSolicitante() {
    this.datos["controls"]["suministro"].setValue(
      this.globals.suministro.toString()
    );
    this.datos["controls"]["tipDocumento"].setValue(
      this.globals.tip_docum.toString()
    );
    this.datos["controls"]["numDocumento"].setValue(
      this.globals.num_docum.toString()
    );
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  validacionCorreoFinal() {
    this.codigoValidacionWeb =
      this.datos.value.codigo1.toString() +
      this.datos.value.codigo2.toString() +
      this.datos.value.codigo3.toString() +
      this.datos.value.codigo4.toString();

    this.flagCodigovalidacion = false;
    if (this.datos.value.correo.toString() == this.correoTemporal) {
      if (this.codigoValidacionWeb == this.codigoValidacion) {
        this.flagCodigovalidacion = true;
        this.flagEnviar = false;
        this.toggle = false;
        this.toastr.success("Validación de correo satisfactoria.", "Atención", {
          closeButton: true,
        });
      } else {
        this.flagEnviar = true;
        this.toggle = true;
        //this.toastr.warning("Código de verificación inválido", "Atención", {
        //  closeButton: true,
        //});
        this.toastr.warning("Secuencia de código errada. Ingrese nuevamente el código o genere un nuevo código", "Atención", {
          closeButton: true,
        });
        return;
      }
    } else {
      this.flagCodigovalidacion = false;
      this.flagEnviar = true;
      this.toggle = true;
      this.datos["controls"]["codigo1"].setValue("");
      this.datos["controls"]["codigo2"].setValue("");
      this.datos["controls"]["codigo3"].setValue("");
      this.datos["controls"]["codigo4"].setValue("");
      this.toastr.warning(
        "El correo ha variado. Debe validar nuevamente",
        "Atención",
        { closeButton: true }
      );
      return;
    }

    //BORRAR BEGIN
    //this.flagCodigovalidacion = true;
    //this.flagEnviar = false;
    //this.toggle = false;
    //BORRAR END
  }

  validaCorreo() {
    if(this.mailValido){
      console.log("Entrando metodo validaCorreo...");
      (<any>Object).values(this.datos.controls).forEach((control) => {
        control.markAsTouched();
      });
      this.correoTemporal = this.datos.value.correo.toString();
      console.log("correoTemporal",this.correoTemporal);
      let camposValidados: boolean= true;
/*
      if(this.globals.tip_docum.toString() ==='TD002'){
        this.datos.value.nombres=" ";
        this.datos.value.materno=" ";
        if(this.datos.value.paterno != "" &&
          this.datos.value.paterno != undefined){
          camposValidados=true;
        }else{
          camposValidados=false;
        }

      }else{*/

        if (this.datos.value.nombres != "" &&
         this.datos.value.nombres != undefined &&
         this.datos.value.paterno != "" &&
         this.datos.value.paterno != undefined &&
         this.datos.value.materno != "" &&
         this.datos.value.materno != undefined &&
         this.datos.value.correo != "" &&
         this.datos.value.correo != undefined) {
            camposValidados=true;
         }else{
            camposValidados=false;
         }

     // }

      if (camposValidados) {
        let remitente = this.datos.value.nombres + ", " + this.datos.value.paterno + " " + this.datos.value.materno;
      console.log("remitente", remitente);
        const body = {
          usuario: remitente,
          //usuario: "",
          email: this.datos.value.correo.toString(),
          sistema: "FINANCIAMIENTO WEB",
          //asunto:"Notificacion Automatica SEDAPAL",
          asunto:this.correoValiAsunto,
          //parrafo_01: "Estimado usuario (a)",
          parrafo_01: this.correoValiParrafo01,
          //parrafo_02: "Por razones de seguridad, la aplicación está validando su correo electrónico.",
          parrafo_02: this.correoValiParrafo02,
          //remitente: "SGC@sedapal.com.pe",
          remitente: this.correoValiRemitente,
          rutaLogo: "https://webapp16.sedapal.com.pe/OficinaComercialVirtual/images/logo-sedapal.png"
        };
        //Obtener Codigo de verificacion
        this.codigoValidacion = "";
        this.supplyService.validarCorreo(body).toPromise().then((response) => {
          this.codigoValidacion = response.bRESP.data.codigoVerificacion;
          if (this.codigoValidacion.length) {
            this.toastr.info(
              "Se le envió codigo de verificación de cuatro dígitos a su correo",
              "Información",
              { closeButton: true }
            );
          } else {
            this.toastr.warning(
              "Verifique con su administrador si la url del servicio esta funcionado!",
              "Atención",
              { closeButton: true }
            );
          }
        }).catch(errorCorreo=>{
          console.error("errorCorreo",errorCorreo);
          this.toastr.warning(
            "No se pudo realizar el envío de la notificación por correo.",
            "Advertencia",
            {
              closeButton: true,
            }
          );
        });
      } else {
        this.toastr.warning(
          "Apellidos, Nombres, Celular del solicitante y Correo Electrónico no pueden ser vacíos",
          "Atención",
          { closeButton: true }
        );
        return;
      }
    }
  }

  stripCorreo() {
    this.mailValido = false;
    let email = this.datos.value.correo;
    //let EMAIL_REGEX = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
    let EMAIL_REGEX = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

    if (email.match(EMAIL_REGEX)) {
      this.mailValido = true;
      this.flagCodigovalidacion = false;
      this.datos["controls"]["codigo1"].setValue("");
      this.datos["controls"]["codigo2"].setValue("");
      this.datos["controls"]["codigo3"].setValue("");
      this.datos["controls"]["codigo4"].setValue("");
    }
    if (!this.mailValido) {
      this.blockUI.stop();
      this.mailValido = false;
      this.toastr.warning("Formato de Correo inválido", "Atención", {
        closeButton: true,
      });
      return;
    }
  }

  stripCelular() {
    let celularValido = false;
    let celular = this.datos.value.celular;
    let CELULAR_REGEX = /^[0-9]{9}$/;
    celular = String(celular);

    if (celular.match(CELULAR_REGEX)) {
      celularValido = true;
    }
    if (!celularValido) {
      this.blockUI.stop();
      this.toastr.warning('Celular debe tener 9 digitos', 'Atención', {closeButton: true});
      return;
    } else {
      let strCelular = celular.toString();
      let primerNumero = strCelular.substring(0,1);

      if (primerNumero != '9') {
        this.blockUI.stop();
        this.toastr.warning('Celular debe empezar con el digito 9', 'Atención', {closeButton: true});
        return;
      }
    }
  }

  stripText(control: FormControl) {
    control.setValue(control.value.replace(/[^0-9]/g, ""));
  }

  validarTelefonoTexto(event: any){
    let telefono = event.target.value;
    let i:any
    for(i=0;i<telefono.length;i++){
        var code=telefono.charCodeAt(i);
            if(code<48 || code>57){
              event.target.value="";
              this.toastr.warning('El telefono debe ser sólo numeros', 'Atención', {closeButton: true});
              return;
            }
      }

  }

  validarCelularTexto(event: any){
    let telefono = event.target.value;
    let i:any
    for(i=0;i<telefono.length;i++){
        var code=telefono.charCodeAt(i);
            if(code<48 || code>57){
              event.target.value="";
              this.toastr.warning('El celular debe ser sólo numeros', 'Atención', {closeButton: true});
              return;
            }
      }

  }



  validForm() {
    (<any>Object).values(this.datos.controls).forEach((control) => {
      control.markAsTouched();
    });

    console.log("this.datos.invalid",this.datos.invalid);
    if (this.datos.invalid) {
      this.toastr.warning(
        "Apellidos, Nombres, Celular del solicitante y Correo Electrónico no pueden ser vacíos",
        "Atención",
        { closeButton: true }
      );
      return false;
    }

    // Validar correo
    /*
    if (!this.flagCodigovalidacion) {
      this.toastr.warning(
        "Es necesario que el correo este validado",
        "Atención",
        { closeButton: true }
      );
      return false;
    }
    */

    // Validar documentos
    for (let index = 0; index < this.dataSource.length; index++) {
      if (this.dataSource[index].docAdjunto === null || this.dataSource[index].docAdjunto === undefined) {
        this.toastr.warning(
          "Adjunte todos los documentos solicitados",
          //"Por lo menos uno de los archivos adjuntos ha excedido el tamaño máximo permitido",
          "Atención",
          { closeButton: true }
        );
        return false;
      } else {
        let strDocAdjunto = this.dataSource[index].docAdjunto;
        strDocAdjunto = strDocAdjunto.replace(/\s/g, "");
        if (strDocAdjunto.length == 0) {
          this.toastr.warning(
            "Adjunte todos los documentos solicitados",
            //"Por lo menos uno de los archivos adjuntos ha excedido el tamaño máximo permitido",
            "Atención",
            { closeButton: true }
          );
          return false;
        }
      }
    }
    /*
    // Validar que no excede la capacidad limite de los archivos
    let flagExcedido: boolean = false;
    //let capacidad:number = 10485760; //parametro se le limit: 10MB * 1024 Kbytes = 1e+7
    let factor: number = 1048576;
    //let capacidad:number = 10485760;
    let capacidad:number = factor * this.limitFile_pdf;
    console.log("capacidad",capacidad);
    this.sizeFile = 0;
    this.filesMap.forEach((value: any) => {
      //this.sizeFile = this.sizeFile + value.file.size;
      this.sizeFile = value.file.size;
      if (capacidad < this.sizeFile) {
        flagExcedido = true;
      }
    });
    console.log("size", this.sizeFile);
    console.log("flagExcedido", flagExcedido);

    if (flagExcedido) {
      this.toastr.warning(
        //"Documentos adjuntos excedieron el limite máximo!",
        "Por lo menos uno de los archivos adjuntos ha excedido el tamaño máximo permitido",
        "Atención",
        { closeButton: true }
      );
      return false;
    }*/

    return true;
  }

  submit() {
    if (this.validForm()) {
      let formValue = this.datos.getRawValue();
      this.data = JSON.parse (localStorage.getItem ('dataRegistro'));
      console.log("this.dataRegistro",this.data);

      let secuenciaSuministro: any = this.data.secuSuministro;
      let codigoOficina: any = this.data.codOficina;
      let docAdjuntos: any = [];
      let j = 0;
      this.filesMap.forEach((value: any, key: any) => {
        docAdjuntos.push({
          idBandeja: 0,
          tipoDocArchivo: value.item.tipo,
          nombreArchivo: this.getFileName(j, value.file, formValue),
          estadoDocumento: "DC001",
          motivoRechazo: ' ',
        });
        j++;
      });
      console.log("docAdjuntos",docAdjuntos);
      formValue.telefono = formValue.telefono.replace(/\s/g, "");
      formValue.correo = formValue.correo.replace(/\s/g, "");

      if (formValue.telefono && formValue.telefono.length == 0) {
        formValue.telefono = "0";
      }

      let formData: FormData = new FormData();
      formData.append("suministro", formValue.suministro);
      formData.append("secuenciaSuministro", secuenciaSuministro);
      formData.append("codigoOficina", codigoOficina);
      formData.append("codigoParentesco", formValue.parentesco);
      formData.append("paterno", formValue.paterno);
      formData.append("materno", formValue.materno);
      formData.append("nombres", formValue.nombres);
      formData.append("tipoDocumento", formValue.tipDocumento);
      formData.append("numDocumento", formValue.numDocumento);
      formData.append("telefono", formValue.telefono);
      formData.append("celular", formValue.celular);
      formData.append("correo", formValue.correo);
      formData.append("estadoSolicitud", "SO002");
      formData.append("motiEstadoSolic", "MS001");
      formData.append("docAdjuntos", JSON.stringify(docAdjuntos));

      this.filesMap.forEach((value: any) => {
        formData.append("document", value.file, value.file.name);
      });

      this.financiamientoApiService
        .registrarSolicitante(formData)
        .toPromise()
        .then((response: any) => {
          console.log(response);
          console.log("response.estado", response.estado);
          let mensaje = response.resultado.mensaje;
          console.log("response.resultado.mensaje", response.resultado.mensaje);
          mensaje = mensaje.replace(/\s/g, "");
          console.log("response.resultado.mensaje", mensaje);
          if (response.estado === "OK" && mensaje.length == 0) {
            let data: any = {
              idBandeja: response.resultado.idBandeja,
              usuario: response.resultado.usuario,
              fechaActual: response.resultado.fechaActual,
              programa: response.resultado.programa,
              fechaUltimoMovimiento: response.resultado.fechaUltimoMovimiento,
              fechaAlta: response.resultado.fechaAlta,
              suministro: response.resultado.suministro,
              secuenciaSuministro: response.resultado.secuenciaSuministro,
              numeroAcuerdo: response.resultado.numeroAcuerdo,
              codigoOficina: response.resultado.codigoOficina,
              fechaSolicitud: response.resultado.fechaSolicitud,
              tipoSolicitante: response.resultado.tipoSolicitante,
              paternoSolicitante: response.resultado.paternoSolicitante,
              maternoSolicitante: response.resultado.maternoSolicitante,
              nombresSolicitante: response.resultado.nombresSolicitante,
              tipoDocumento: response.resultado.tipoDocumento,
              numDocumento: response.resultado.numDocumento,
              telefonoSolicitante: response.resultado.telefonoSolicitante,
              celularSolicitante: response.resultado.celularSolicitante,
              correoSolicitante: response.resultado.correoSolicitante,
              numArchivo: response.resultado.numArchivo,
              deudaTotal: response.resultado.deudaTotal,
              numCuota: response.resultado.numCuota,
              montoCuota: response.resultado.montoCuota,
              numRecibo: response.resultado.numRecibo,
              estadoSolicitante: response.resultado.estadoSolicitante,
              motivoEstadoSolicitante: response.resultado.motivoEstadoSolicitante,
              estadoTramite: response.resultado.estadoTramite,
              tipoTramite: response.resultado.tipoTramite,
              indicadorDescarga: response.resultado.indicadorDescarga,
              indicadorCorreo: response.resultado.indicadorCorreo
            };
            console.log("data", data);
            localStorage.setItem("dataSolicitante", JSON.stringify(data));
            this.globals.tipo_form_solicitante = 1;
            this.router.navigate(["/mensaje-registro"]);

          } else {
            this.toastr.error(response.resultado.mensaje, "Error", {
              closeButton: true,
            });
          }
        }).catch(errorCorreo=>{
          console.error("errorCorreo",errorCorreo);
          this.toastr.warning(
            "No se logró actualizar la bandeja. Inténtelo nuevamente",
            "Advertencia",
            {
              closeButton: true,
            }
          );
        });
    }
  }

  getFileName(j: number, file: any, formValue: any) {
    let returned: string = '';
    let nroSuministro = formValue.suministro;
    let nroDocumento = formValue.numDocumento;
    let tipoExt = file.type === 'image/jpeg' ? 'jpg' : 'pdf';
    returned = nroSuministro + "_" + nroDocumento + "_" + (j + 1) + "." + tipoExt;

    return returned;
  }

  //Focos para los codigos 1-4
  processKeyUp(e, el) {
    el.focus();
  }

}
